var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sedap-base-table" },
    [
      _c("h3", { staticClass: "sedap-base-table__title" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            stripe: _vm.stripe,
            "header-cell-class-name": _vm.tableClasses.header,
            "cell-class-name": _vm.tableClasses.row,
            emptyText: _vm.emptyText
          }
        },
        [
          _vm._l(_vm.columns, function(column, index) {
            return column.type === "icon"
              ? _c("el-table-column", {
                  key: "col-" + column.key + "-" + index,
                  attrs: {
                    label: column.label,
                    width: column.width,
                    sortable: column.sortable,
                    align: column.align
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            !column.tooltip
                              ? _c("i", {
                                  class: [
                                    scope.row[column.key],
                                    "font-size-16px"
                                  ],
                                  style: {
                                    color:
                                      (column.color &&
                                        column.color(scope.row)) ||
                                      ""
                                  }
                                })
                              : _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: column.tooltip(scope.row),
                                      effect: "dark",
                                      placement: "top",
                                      "popper-append-to-body": ""
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _c("i", {
                                        class: [
                                          scope.row[column.key],
                                          "font-size-16px"
                                        ],
                                        style: {
                                          fontSize: "",
                                          color:
                                            (column.color &&
                                              column.color(scope.row)) ||
                                            ""
                                        }
                                      })
                                    ])
                                  ]
                                )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              : _vm._e()
          }),
          _vm._v(" "),
          _vm._l(_vm.columns, function(column, index) {
            return column.type !== "icon" && column.key !== "actions"
              ? _c("el-table-column", {
                  key: "col-" + column.key + "-" + index,
                  attrs: {
                    prop: column.key,
                    label: column.label,
                    width: column.width,
                    sortable: column.sortable,
                    align: column.align
                  }
                })
              : _vm._e()
          }),
          _vm._v(" "),
          _vm._l(_vm.columns, function(column, index) {
            return column.key === "actions"
              ? _c("el-table-column", {
                  key: "actions-" + column.key + "-" + index,
                  attrs: {
                    prop: column.key,
                    label: column.label,
                    width: column.width,
                    sortable: column.sortable,
                    align: column.align
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("ActionsMenu", {
                              attrs: {
                                actions: _vm.filterVisibleActions(
                                  scope.row.actions
                                ),
                                rowData: _vm.tableData[scope.$index]
                              },
                              on: {
                                onAction: function($event) {
                                  return _vm.$emit("onAction", $event)
                                }
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("pagination", [
        _vm.pagination.show
          ? _c("Pagination", {
              attrs: { pagination: _vm.pagination },
              on: {
                pageChange: function($event) {
                  return _vm.$emit("pageChange", $event)
                }
              }
            })
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-788b803f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-788b803f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Tables/BaseTable/BaseTable.vue
// module id = null
// module chunks = 